import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "opp-near-card" }
const _hoisted_2 = { class: "flex items-start space-x-4 text-base sm:text-sm" }
const _hoisted_3 = { class: "flex-none mt-1" }
const _hoisted_4 = ["alt", "title"]
const _hoisted_5 = ["src", "alt", "title"]
const _hoisted_6 = { class: "flex-grow truncate" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-gray-600 truncate" }

import {computed, Ref, ref} from "vue";
import {LearningModuleDtoLightWeight} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningModuleCardStacked',
  props: {
    guide: {},
},
  setup(__props) {

// @ts-ignore
const props = __props
const guide: LearningModuleDtoLightWeight = props.guide;
const url = `/${guide.id}/${guide.slug}`;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(guide).imageUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: url,
              alt: _unref(guide).topic,
              title: _unref(guide).topic,
              class: "guide-img-container"
            }, [
              _createElementVNode("img", {
                class: "object-cover w-8 rounded-lg shadow-lg",
                src: _unref(guide).imageUrl,
                alt: _unref(guide).topic,
                title: _unref(guide).topic
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "block font-medium hover:underline",
          href: url,
          title: _unref(guide).topic
        }, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(guide).topic), 1)
        ], 8, _hoisted_7),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(guide).learningModelCategories.join(", ")), 1)
      ])
    ])
  ]))
}
}

})